<template>
	         	<div class="col-12 sec_content self_reported_courses">
              <template>
                <div class="row accordion">
									<div class="col-12 accordion_crd">
                    <b-card-header header-tag="header" class="row sec_hd" role="tab" block v-b-toggle="'courses_' + parentCategory.uuid" variant="info">
                      <div class="col-1 ic_container">
                        <div class="ic ic-expand_r"></div>
                        <div class="ic ic-collapse_r"></div>
                      </div>
                      <div class="col-11 hd_txt hd_sec2">
												<div class="row">
                        	<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 title" v-html="getParentLabel(parentCategory)"></div>
													<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 progress_bar_sec" v-if="formattedProgramGuide.showCategoryProgress">
														<div class="col-12" v-if="((courseStructure.length > 0 || (parentCategory.title.indexOf('Exam') !=-1 && parentCategory.total>1)) && !hideCategoryProgress)">
															<program-category-score-and-progress-bar :hideScoreForStudent="formattedProgramGuide.hideScoreForStudent" :performance="parentCategory.performance" :completeCount="parentCategory.completed"
			                        	:totalCount="parentCategory.total" :inProgressCount="parentCategory.inProgress">
			                        </program-category-score-and-progress-bar>
														</div>
		                        <div class="col-12 progress_info_sec" v-else-if="!parentCategory.planningStream && !hideCategoryProgress">
															<div class="txt_container completed" v-if="parentCategory.total === parentCategory.completed">
																<div class="ic_container">
																	<span class="ic ic26-complete"></span>
																</div>
																<div class="status_info">
																	<span>Completed</span>
																</div>
															</div>
                              <div class="txt_container pending" v-else>
                                <div class="ic_container">
                                  <span class="ic ic24-hour-glass"></span>
                                </div>
                                <div class="status_info">
                                  <span>Pending</span>
                                </div>
                              </div>

														</div>
													</div>
												</div>
                      </div>
                    </b-card-header>

                    <div class="row row_content" v-if="courseStructure.length > 0">
                      <div class="col-12">
                        <b-collapse :id="'courses_'+parentCategory.uuid" visible role="tabpanel" class="row course_list_container">
                          <div class="col-12 course_row" v-for="(course, index) in courseStructure" :key="course.originUuid" :class="course.waiveStatus ? 'waived_course_row course_row_' + index : 'course_row_' + index">
                          <template v-if="course.entityType !== 'folder'">
                            <div class="row">
                              <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 title">
                                <div class="thumbnail_sec">
                                  <div class="thumbnail" :style="{background: setThumbnailBgColor(course.originUuid)}">
																		<div v-html="setThumbnailTitle(course)"></div>
                                  </div>
																	<template v-if="(course.entityType === 'catalog')">
																		<div class="credit_info">
																			{{course.creditsEarned}} credits
																		</div>
																	</template>
                                </div>
                                <div class="row col_title">
                                  <div class="col-10" v-if="course.entityType === 'deliverycontext' && transactionValidity.transactionValid && course.releaseStatus" :class="((course.entityType === 'deliverycontext') ? 'active_link' : '')" @click="navigateToCourseDashboard(course)">
																		{{course.title}}
																	</div>

                                  <div class="col-10" v-if="course.entityType === 'deliverycontext' && transactionValidity.transactionValid && !course.releaseStatus">
																		{{course.title}}
																	</div>

                                 <template v-if="course.entityType === 'deliverycontext' && transactionValidity.transactionValid">
                                    <div class="col-2 lnk_container">
                                      <b-link class="btn_lock_unlock" v-b-modal="'releaseModal_' + parentCategory.uuid + index" style="float: right; margin-top: -9px; margin-right: 9px;" v-if="!course.waiveStatus && !course.releaseStatus">
																				<span class="ic22-lock"></span>
																			</b-link>
							                			</div>
																		<div class="modal_popup_container custom_modal_v4 course_unlock_modal">
	                                    <b-modal title="Course is Locked" class="description_modal" :id="'releaseModal_' + parentCategory.uuid + index" ok-only ok-title="ok">

																				<div class="ic_container">
																					<span class="ic ic22-lock"></span>
																				</div>

																				<div class="row">
																					<div class="col-12 txt_row">
																						{{course.title}}
																					</div>
	                                        <div class="col-12 txt_row">
	                                          <div v-html="course.releaseLogicDetail"></div>
	                                        </div>
	                                      </div>
	                                    </b-modal>
																		</div>
                                    <div class="modal_popup_container custom_modal_v4 course_unlock_modal">
                                      <b-modal title="Course Waived" class="description_modal" :id="'waiveModal_' + parentCategory.uuid + index" ok-only ok-title="ok">

                                        <div class="ic_container">
															            <span class="btn_waive">
															              <span class="course_w">W</span>
															            </span>
															          </div>

                                        <div class="row txt_row mt-2">
																					<div class="col-3 fld_label">
																						Course
																					</div>
                                          <div class="col-9 fld_val">
                                            {{course.title}}
                                          </div>
																				</div>

																				<div class="row txt_row mt-4">
																          <div class="col-3 fld_label">
																            Reason
																          </div>
																          <div class="col-9 fld_val">
																						<div v-html="course.waiveLogicDetail"></div>
																          </div>
																        </div>

                                      </b-modal>
                                    </div>
                                  </template>

                                  <div class="col-10" v-if="course.entityType !== 'deliverycontext' || !transactionValidity.transactionValid">
																		{{course.title}}
																	</div>
																	<div :id="'entityDesc_' + index" class="description" v-if="course.description">
																		<span class="desc_txt ace_sec_txt shrt_des_my_prog" v-html="course.description">
                                    </span>
																	</div>

																	<template v-if="course.description">
																		<div class="lnk_container" :class="showMoreDescLnk(index)">
																			<b-link v-b-modal="'entityDescModal_' + parentCategory.uuid + index">
																				{{ $tf('more') }}
																			</b-link>
																		</div>
																		<div class="modal_popup_container custom_modal_v4 modal_courseDesc_myProg">
																			<b-modal class="description_modal" :title="course.title" :id="'entityDescModal_' + parentCategory.uuid + index" ok-only ok-title="ok">
																				<div class="ic_container">
																					<!--
																					<span class="ic ic22-lock"></span>
																				-->
																				</div>

																				<div class="row">
																					<!--
																					<div class="col-12 txt_row">
																						{{course.title}}
																					</div>
																					-->
	                                        <div class="col-12 txt_row">
	                                          <div v-html="course.description"></div>
	                                        </div>
																				</div>
																			</b-modal>
																		</div>
                                  </template>
                                </div>
                              </div>
                              <template v-if="(course.entityType === 'deliverycontext')">
                                <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 progress_bar_sec">
                                  <program-course-score-and-progress-bar v-if="(transactionValidity.transactionValid && (course.releaseStatus || course.waiveStatus))" :hideScoreForStudent="formattedProgramGuide.hideScoreForStudent" :course-id="course.originUuid" :waiveStatus="course.waiveStatus" @progressSummary="aggregateProgressSummary"></program-course-score-and-progress-bar>

																	<template v-if="transactionValidity.transactionValid">
																		 <div class="col-12 lnk_container waived_course_info">
																			 <b-link class="" v-b-modal="'waiveModal_' + parentCategory.uuid + index" v-if="course.waiveStatus">
																				 <span class="course_w">Waived</span>
																			 </b-link>
																		 </div>
																	 </template>
                                </div>
                              </template>

															<template v-if="(course.entityType === 'catalog' && !formattedProgramGuide.useSISEnrollment)">
																<div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 progress_status">
	                                <div class="btn_container">
	                                  <b-button :class="courseStatusBackgroundMap[course.courseStatus]" @click="openStatusDropDown(course)">
	                                    <div style="color: #fff;">{{courseStatusMap[course.courseStatus]}}</div>
	                                  </b-button>
	                                </div>
	                                <div class="ic_container">
	                                  <span class="ic icon-pencil" :id="'courseStatusSetting-' + course.originUuid" style="cursor: pointer;" @click="openStatusDropDown(course)"></span>
	                                  <div class="course_status_popup" :id="'courseStatusPopup-' + course.originUuid"></div>
	                                </div>
																</div>
															</template>

															<template v-if="(course.entityType === 'catalog' &&  formattedProgramGuide.useSISEnrollment)">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                  <div class="enrollment_pending_info">
																		<div class="txt_container">
																			<div class="ic_container">
	                                      <span class="ic ic22-hour-glass" style="margin-top: -1px;"></span>
	                                    </div>
	                                    <div class="status_info">
	                                      <span class="txt" style="padding-right: 13px;">Enrollment Pending</span>
	                                    </div>
	                                  </div>
																	</div>
                                </div>
                              </template>

                            </div>
                          </template>
                          <template v-if="course.entityType === 'folder'">
                              <program-guide-course-structure  :courseStructure="getCourses(course)" :parentCategory="course" firstCategory="false" :formattedProgramGuide="formattedProgramGuide" :transactionValidity="transactionValidity" > </program-guide-course-structure>
                          </template>

                          </div>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="(courseStructure.length ===0 && firstCategory !=='false' )">
  							<b-jumbotron>
          				<h4 class="text-center ace_sec_txt">Program Status is currently not available.</h4>
        				</b-jumbotron>
              </template>
			  		</div>
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import ProgramCourseScoreAndProgressBar from './ProgramCourseScoreAndProgressBar'
  import ProgramCategoryScoreAndProgressBar from './ProgramCategoryScoreAndProgressBar'
  import { StorageFactory } from '../../../storageFactory'
  import VClamp from 'vue-clamp'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'program-guide-course-structure',
    props: ['courseStructure', 'parentCategory', 'firstCategory', 'transactionValidity', 'formattedProgramGuide', 'hideCategoryProgress'],
    components: {
      ProgramCourseScoreAndProgressBar,
      ProgramCategoryScoreAndProgressBar,
      VClamp
    },
    data: () => {
      return {
        courses: [],
        DEFAULT_TYPE: 'MAJOR',
        DEFAULT_RETURN_TO: 'exploreIntro',
        EXPLORE_RESULTS: 'exploreProgramGuideResults',
        LEARNER_PROGRAM_LIST: 'learnerProgramList',
        userName: localStore.getItem('userFullName'),
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        },
        score: 0,
        performance: 0,
        childrenCount: 0,
        childrenCompleteCount: 0,
        progressSummaries: [],
        isScoreNotAvailable: true,
        transactionValidity: {}
      }
    },
    mounted () {
//      this.loadDataForProgramGuideMyStatus()
    },

    methods: {
      ...mapActions([
        'loadProgramGuide',
        'loadStreamWithStructure',
        'updateProgramCourseStatus',
        'loadCheckTransactionValidity',
        'loadCourseDetailFromServerWithoutStoringInState',
        'loadContinueLearningLast'
      ]),
      resetData () {
        this.score = 0
        this.performance = 0
        this.childrenCount = 0
        this.childrenCompleteCount = 0
        this.courses = []
        this.progressSummaries = [],
        this.isScoreNotAvailable = true
      },
       getCourses (course) {
            let childStructure = course.structure
            if (childStructure) {
              let structure = JSON.parse(childStructure)
              return _.sortBy(structure, 'order')
            }else{
              return []
            }
      },
      getParentLabel(parent){
        if(parent.title ==='Explore'){
            return 'Courses'
        }
        if(parent.planningStream){
            return this.formattedProgramGuide.title
        }

        return parent.title
      },

      returnToClicked () {
        return this.$router.push({ name: this.returnTo })
      },
      deCamelCase () {
        if (!this.returnTo) {
          this.returnTo = this.DEFAULT_RETURN_TO
        }
        if (this.returnTo === this.EXPLORE_RESULTS) {
          return 'return to all results'
        }
        if (this.returnTo === this.LEARNER_PROGRAM_LIST) {
          return 'return to my progress'
        }
        let result = this.returnTo.replace(/([A-Z])/g, ' $1')
        return 'return to ' + result
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      isCategorizedProgressEnabled () {
          return this.isFlagEnabled('learner_dashboard', 'Show Categorized Progress')
      },
      isFinancialInformationEnabled () {
          return this.isFlagEnabled('learner_dashboard', 'Show Financial Information')
      },

      isFlagEnabled (featureId, flagValue) {
        let learnerDB = this.enabledFeatures[featureId]
        if (learnerDB && learnerDB.enabled) {
          let flags = learnerDB.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === flagValue) {
              return flags[i].enabled
            }
          }
        }
        return false;
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      async updateCourseStatus (streamId, status) {
        let data = {
          uuid: streamId,
          status: status
        }
        this.updateProgramCourseStatus(data).then(result => {
          this.populatePlanningStreamStructure()
        })
      },
      openStatusDropDown (course) {
        this.selectedStatus = course.courseStatus
        if (this.clickedCourse) {
          this.closeStatusDropDown(false)
        } else {
          this.clickedCourse = course
          setTimeout(() => {
            this.$refs.courseStatusPopover.$emit('open')
          }, 250)
        }
      },
      closeStatusDropDown (toBeUpdated, status) {
        if (toBeUpdated) {
          this.updateCourseStatus(this.clickedCourse.uuid, status)
        }
        this.clickedCourse = ''
        this.selectedStatus = ''
        this.$refs.courseStatusPopover.$emit('close')
      },
      async navigateToCourseDashboard (course) {
        if (course.entityType === 'deliverycontext') {
          this.$store.commit('LOAD_COURSE', {})
          this.$store.commit('LOAD_CLASS_SUMMARY', {})
          this.$store.commit('LOAD_COURSE_TOPICS', {})
          this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
          let courseId = course.originUuid
          let courseDetail = await this.loadCourseDetailFromServerWithoutStoringInState(courseId)

          let options = await this.loadContinueLearningLast({uuid: courseId, loadDataFromServer: true})
          if (options && options.length > 0) {
            if (options[0].title === 'EXTRENAL_COURSE_LAUNCH') {
              let _window = window.open(options[0].uri, '_blank')
               setTimeout(() => {
                  _window.location = options[1].uri
                }, 5000)
              return
            }
          }

          if (courseDetail.showDeadLine) {
            return this.$router.push({name: 'learnerObservationReport', params: {uuid: courseId}})
          } else {
            return this.$router.push({name: 'courseDashboard', params: {uuid: courseId}})
          }
        }
      },
      aggregateProgressSummary (progressSummary) {
        if ((progressSummary.status === 1) || (progressSummary.status === 2)) {
          this.isScoreNotAvailable = false
          this.progressSummaries.push(progressSummary)
          this.performance += progressSummary.performance
        }
        this.childrenCount += progressSummary.childrenCount
        this.childrenCompleteCount += progressSummary.childrenCompleteCount
        setTimeout(() => {
          this.score = (this.performance / this.progressSummaries.length).toFixed(2)
        }, 1000)
      },
      showMoreDescLnk (id) {
        let entityDescHeight = $('#entityDesc_' + id + ' .desc_txt').height()
				if (entityDescHeight > 45) {
          return 'show_more_link'
        } else {
          return 'hide_more_link'
        }
      },
      showMoreDescLink (desc) {
        if(desc){
          desc = desc.replace( /(<([^>]+)>)/ig, '');
        }
        if (desc && desc.length > 101) {
          return true
        } else {
          return false
        }
      },
      showDesc (fullDesc){
        if(fullDesc){
          let desc = fullDesc.replace( /(<([^>]+)>)/ig, '');
          if(desc.length>101){
            return desc.substring(0,101) + '...'
          }
          return desc;
        }
        return fullDesc
      },
      statusClass (score, hideScore) {
        if (score && !this.isScoreNotAvailable && !hideScore) {
          if (score >= 90) {
            return 'gradeA'
          } else if (score >= 80 && score < 90) {
            return 'gradeB'
          } else if (score >= 65 && score < 80) {
            return 'gradeC'
          } else if (score >= 40 && score < 65) {
            return 'gradeD'
          } else if (score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      }
    },
    computed: {
      ...mapState({
        'planningStream': state => state.dashboard.planningStream,
        'programGuideObject': state => state.programguide.programGuideObject,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'packages': state => state.institution.packages
      }),
      formattedProgramGuide () {
        let formattedProgramGuide = this.programGuideObject
        return formattedProgramGuide
      },
      programGuideType () {
        let programGuideType = this.type
        if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
          programGuideType = this.DEFAULT_TYPE
        }
        return programGuideType
      }
    }
  }
</script>

<style scoped>
	.hide_more_link {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideCourseStructure.vue